export const allowedRefPaths = ['localhost', 'coolblue'];

export function isReferrerCoolblue(referrer: string | null | undefined) {
  let isFromCoolblue = false;

  if (!referrer) return isFromCoolblue;

  allowedRefPaths.forEach((path: string) => {
    if (referrer.includes(path)) {
      isFromCoolblue = true;
    }
  });

  return isFromCoolblue;
}
